import { addLink, bindKeymapWithCommand } from '@atlaskit/editor-common/keymaps';
import { keymap } from '@atlaskit/editor-prosemirror/keymap';
import { showLinkingToolbarWithMediaTypeCheck } from '../commands/linking';
export default function keymapPlugin(schema) {
  var list = {};

  // Ignored via go/ees005
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  bindKeymapWithCommand(addLink.common, showLinkingToolbarWithMediaTypeCheck, list);
  return keymap(list);
}